module.exports = __webpack_public_path__ + "static/ic_collect.4873f4b4.png";